export default [
  {
    content: "개인 보호구 착용",
    isChecked: "",
  },
  {
    content: "구멍줄(LIFE LINE) 설치 후 작업",
    isChecked: "",
  },
  {
    content: "작업 전 안전벨트 체결 상태 확인",
    isChecked: "",
  },
  {
    content: "작업 전 상하 중복작업 확인 철저",
    isChecked: "",
  },
  {
    content: "하부에 안전 난간(Fence)을 설치",
    isChecked: "",
  },
  {
    content: "작업장 주변 유동 인원 통제",
    isChecked: "",
  },
  {
    content: "해체 시 우선 순위를 확인",
    isChecked: "",
  },
  {
    content: "표준 작업 절차 준수",
    isChecked: "",
  },
  {
    content: "설치/해제 후 작업장 정리 정돈",
    isChecked: "",
  },
  {
    content: "조명상태 확인",
    isChecked: "",
  },
  {
    content: "작업 전후 청소 및 정리정돈",
    isChecked: "",
  },
];
